import { GET_DIVISION_SAMPLES, GET_SPECIFIC_DIVISION_SAMPLE, ADD_DIVISION_SAMPLE, EDIT_DIVISION_SAMPLE, DELETE_DIVISION_SAMPLE, DIVISION_SAMPLES_LOADING, CLEAR_DIVISION_SAMPLES } from '../types';
import { IAction, IDivisionSample } from '../../types/interfaces';

const initialState = {
  division_samples: [],
  info: {},
  loading: false
};

interface IState {
  division_samples: IDivisionSample[];
}

export default function(state: IState = initialState, action: IAction) {
  switch (action.type) {
    case GET_DIVISION_SAMPLES:
      return {
        ...state,
        division_samples: action.payload,
        loading: false
      };
    case GET_SPECIFIC_DIVISION_SAMPLE:
      return {
        ...state,
        info: action.payload,
        loading: false
      };
    case DIVISION_SAMPLES_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_DIVISION_SAMPLES:
      return {
        ...state,
        division_samples: []
      };
    case ADD_DIVISION_SAMPLE:
      return {
        ...state,
        division_samples: [action.payload, ...state.division_samples],
      };
    case EDIT_DIVISION_SAMPLE:
      return {
        ...state,
        division_samples: state.division_samples.map(e => e.id == action.payload.id ? action.payload : e)
      };
    case DELETE_DIVISION_SAMPLE:
      return {
        ...state,
        division_samples: state.division_samples.filter(e => e.id !== action.payload)
      };
    default:
      return state;
  }
}
